export const Footer = () => (
  <footer
    data-testid="footer"
    className="border-t border-cream bg-sand py-12 px-6 md:px-12 text-moss text-xs"
  >
    <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6">
      <div className="flex items-center gap-3">
        <span className="font-display text-base font-semibold text-ink">Elisabete Lopes</span>
        <span>• LymphoMetabolic Massage Academy • CPD Certified</span>
      </div>
      <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
        <span>SE24 &amp; SW9 London</span>
        <a
          data-testid="footer-website-link"
          href="https://www.elisabetelopes.co.uk"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-ink transition-colors"
        >
          elisabetelopes.co.uk
        </a>
        <a
          data-testid="footer-email-link"
          href="mailto:elisabetelopes445@gmail.com"
          className="hover:text-ink transition-colors"
        >
          elisabetelopes445@gmail.com
        </a>
        <a data-testid="footer-phone-link" href="tel:+447479815308" className="hover:text-ink transition-colors">
          +44 7479 815308
        </a>
        <span>Mon–Fri 10am–5pm</span>
      </div>
    </div>
  </footer>
);
